import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

type IconButtonProps = {
  icon: IconDefinition;
  onClick?: () => void;
  ariaLabel: string;
  theme?: ThemeEnum;
  className?: string;
};

export default function IconButton({
  icon,
  onClick,
  ariaLabel,
  theme = ThemeEnum.light,
  className,
}: IconButtonProps) {
  const isDark = theme === ThemeEnum.dark;
  return (
    <button
      data-testid="icon-button"
      onClick={onClick}
      className={clsx(
        "hover:bg-button-ghost-hover relative size-8 shrink-0 overflow-hidden rounded-[100px] transition-colors",
        className,
      )}
      aria-label={ariaLabel}
    >
      <div className="absolute inset-[12.5%] flex items-center justify-center">
        <FontAwesomeIcon
          icon={icon}
          className={clsx(
            "size-5",
            isDark ? "text-primary-on-dark" : "text-primary",
          )}
        />
      </div>
    </button>
  );
}
